import type { T_Maybe } from '@tryiris-ai/js-types';
import { createContext } from 'react';
import type { Wiring } from './types.js';

/** Wiring context. */
export const Context = createContext<T_Maybe<Wiring>>(undefined);
